module.exports = __webpack_public_path__ + "static/img/icon_set_origin.e1a1f5ad.svg";